async function devtricker_process_getDevtrickerNonce() {
    try {
        let nonce = devtricker_session_getNonce();

        if (!nonce) {
            nonce = await devtricker_ajax_get_getDevtrickerNonce();
            devtricker_session_setNonce(nonce);
        }

        return nonce;

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR, 'Error when trying to get the devtricker_nonce. The nonce is required to do all custom user transactions.');
        throw error;
    }
}